const routes = [
  {
    path: '/coupons',
    redirect: { name: 'coupons' },
  },
  {
    path: '/coupons',
    name: 'YourgiProCoupons',
    component: () => import('@/pages/Coupons.vue'),
    meta: {
      pageTitle: 'Coupons',
      requiresAuth: true,
      resourceName: 'COUPON',
    },
    children: [
        {
            path: '',
            name: 'coupons',
            component: () => import('./pages/Coupons.vue'),
        },
        {
          path: 'create',
          name: 'create-coupon',
          component: () => import('./pages/CreateCoupon.vue'),
        },
        {
            path: 'edit/:id',
            name: 'edit-coupon',
            component: () => import('./pages/CreateCoupon.vue'),
          },
      ],
  },
]
export default routes